export default __webpack_public_path__ + "static/B104-d533bb58f7438363f4340edfd3c0c80a.jpg";